import { ReturnTypeEnum } from "@redotech/redo-model/return";
import {
  AssessmentFieldSchema,
  ReturnAssessmentDefinitionSchema,
  ReturnAssessmentSchema,
} from "@redotech/redo-model/return-assessments/assessment-schemas";
import * as z from "zod/v4";

export const createAssessment = {
  name: "createAssessment" as const,

  input: z.object({
    name: z.string().min(1, "Assessment name is required"),
    kind: z.enum(ReturnTypeEnum),
    fields: z.array(AssessmentFieldSchema).optional().default([]),
    iconName: z.string().min(1).optional(),
    iconColor: z.string().min(1).optional(),
  }),

  output: z.object({
    schema: ReturnAssessmentSchema,
    definition: ReturnAssessmentDefinitionSchema,
  }),
};
